<template>
  <div class="edit-role-tab">
    <div
      v-for="(role, index) in tabList"
      :key="role.v4"
      :class="['tab-item', role.v4 === current.v4 ? 'tab-item-active' : '']"
      @click="$emit('change', role)"
    >
      <div :class="['header', index === 0 ? 'recommend' : '']">{{ index === 0 ? "最佳推荐" : "下位替换" }}</div>
      <div class="role-wrapper">
        <img :src="role.icon" class="avatar" />
        <span class="name">{{ role.name }}</span>
      </div>
      <i v-if="index !== 0" class="el-icon-close remove-item" @click.stop="$emit('remove', role)"></i>
      <!-- 遮罩 -->
      <div v-if="role.v4 === current.v4" class="mask">
        <div class="lt"></div>
        <div class="rt"></div>
        <div :class="[index === 0 ? 'lb' : 'lb-out']"></div>
        <div class="rb"></div>
      </div>
    </div>
    <div v-if="tabList.length < 3" class="tab-item append" @click="$emit('append')">
      <div class="header">下位替换</div>
      <div class="add-wrap">
        <img class="add" src="@/assets/zs_imgs/zbtj/role-add.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EditRoleTab",
  props: { tabList: { type: Array, default: () => [] }, current: { type: Object, default: () => ({}) } }
};
</script>
<style lang="less" scoped>
.edit-role-tab {
  line-height: 1;
  display: flex;
  column-gap: 8px;
  padding-bottom: 8px;
  .tab-item {
    position: relative;
    padding: 6px 6px 0;
    box-sizing: content-box;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    .recommend {
      background: url("~@/assets/zs_imgs/zbtj/star-mini-yellow.png") left 7px center / 9px 9px no-repeat,
        url("~@/assets/zs_imgs/zbtj/star-mini-yellow.png") right 7px center / 9px 9px no-repeat;
    }
    .header {
      width: 149px;
      line-height: 21px;
      color: #333;
      font-size: 12px;
      text-align: center;
      border-radius: 5px;
      background-color: #d2d5db;
    }
    .role-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 8px;
      height: 56px;
      .avatar {
        width: 36px;
        height: 36px;
        border: 1px solid #fff;
        border-radius: 36px;
      }
      .name {
        color: #333;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .add {
    }

    .remove-item {
      position: absolute;
      right: -10px;
      top: -10px;
      color: #fff;
      cursor: pointer;
    }
  }
  .tab-item-active {
    background-color: #fff;
  }
  .append {
    cursor: pointer;
    .add-wrap {
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      .add {
        width: 21px;
        height: 21px;
      }
    }
  }
}
/** 角色选中效果 */
.mask {
  position: absolute;
  height: 8px;
  width: 100%;
  left: 0;
  bottom: -8px;
  background-color: #fff;
  .lt,
  .rt,
  .lb,
  .rb {
    position: absolute;
  }
  .lt,
  .rt {
    top: -10px;
    width: 10px;
    height: 10px;
  }
  .lb,
  .rb {
    bottom: -8px;
    width: 8px;
    height: 8px;
  }
  .lt,
  .lb {
    left: 0;
  }
  .rt,
  .rb {
    right: 0;
  }
  .lt {
    background-image: radial-gradient(circle at right top, transparent 10px, #fff 10px);
  }
  .rt {
    background-image: radial-gradient(circle at left top, transparent 10px, #fff 10px);
  }
  .lb {
    background-image: radial-gradient(circle at right bottom, transparent 8px, #fff 8px);
  }
  .lb-out {
    position: absolute;
    left: -8px;
    bottom: 0;
    width: 8px;
    height: 8px;
    background-image: radial-gradient(circle at left top, transparent 8px, #fff 8px);
  }
  .rb {
    right: -8px;
    bottom: 0;
    background-image: radial-gradient(circle at right top, transparent 8px, #fff 8px);
  }
}
</style>
